import { SocketChannel } from '../core/channel'
import { EVENTS_ENUM } from './events'
import { updateBalanceEvent } from './events/updateBalance'

class BalanceChannel extends SocketChannel {
  constructor() {
    super()
    this.register(EVENTS_ENUM.UPDATE_BALANCE, updateBalanceEvent)
    this.register(EVENTS_ENUM.UNNAMED, updateBalanceEvent)
  }
}

export const balanceChannel = new BalanceChannel()
